<template>
  <div>
    <div>
      <span>{{ date }}</span>
    </div>
  </div>
</template>
<script>
import moment from "moment";

export default {
  name: "CellRendererPlotDate",
  data() {
    return {
      noValue: "-",
    };
  },
  computed: {
    date() {
      if (!this.params.value) return this.noValue;
      return this.params.value.seconds != null
        ? moment(this.params.value.seconds * 1000).format("YYYY/MM/DD HH:mm")
        : this.noValue;
    },
  },
};
</script>

<style lang="scss" scoped></style>
